<ul
    class="agpr-layoutBlockAdder"
    [ngClass]="{ 'agpr-layoutBlockAdder--nowrap': isInline }"
>
    @for (blockType of blockTypes; track blockType; let i = $index) {
        @if (draggable) {
            <li
                class="agpr-layoutBlockAdder-item agpr-layoutBlockAdder-item--draggable"
                [ngClass]="{ 'agpr-layoutBlockAdder-item--inline': isInline }"
            >
                <agpr-button
                    [id]="id + '_blockType_' + blockType.key"
                    [disabled]="!blockType.canAdd || disabled"
                    [tooltip]="blockType.canAdd ? blockType.label : blockType.reachLimitMessage | localize"
                    [dndDraggable]="blockType"
                    dndEffectAllowed="copy"
                    dndType="blockType"
                    [dndDisableIf]="!blockType.canAdd || disabled"
                    (dndStart)="onDragBlockTypeStart(blockType)"
                    (dndEnd)="onDragBlockTypeComplete()"
                    (click)="addBlock(blockType, $event)"
                    [style]="buttonTypes.big"
                >
                    <div class="agpr-layoutBlockAdder-item-dragHandle">
                        <span class="agpr-layoutBlockAdder-item-dragHandle-icon"></span>
                    </div>
                    <div class="agpr-layoutBlockAdder-itemIcon">
                        @for (ratio of layoutBlockTypesEnumToFlexMap.get(blockType.key); let idx = $index; track idx) {
                            <div
                                class="agpr-layoutBlockAdder-itemIcon-rectangle"
                                [style.flex]="ratio"
                            ></div>
                        }
                    </div>
                    <span>{{ blockType.label | localize }}</span>
                </agpr-button>
        } @else {
            <li
                class="agpr-layoutBlockAdder-item"
                [ngClass]="{ 'agpr-layoutBlockAdder-item--inline': isInline }"
            >
                <agpr-button
                    class="agpr-layoutBlockAdder-itemButton"
                    [id]="id + '_blockType_' + blockType.key"
                    [tooltip]="blockType.canAdd ? blockType.label : blockType.reachLimitMessage | localize"
                    [disabled]="!blockType.canAdd || disabled"
                    (click)="addBlock(blockType, $event)"
                    [style]="buttonTypes.big"
                >
                    <div class="agpr-layoutBlockAdder-itemIcon">
                        @for (ratio of layoutBlockTypesEnumToFlexMap.get(blockType.key); let idx = $index; track idx) {
                            <div
                                class="agpr-layoutBlockAdder-itemIcon-rectangle"
                                [style.flex]="ratio"
                            ></div>
                        }
                    </div>
                    <span>{{ blockType.label | localize }}</span>
                </agpr-button>
            </li>
        }
    }
</ul>
